import apiClient from "./axios";
import { ApiResponse } from "../types";

export interface AnalyticsOverview {
  users: {
    total: number;
    byTier: {
      tier0: number;
      tier1: number;
      tier2: number;
      tier3: number;
    };
    premium: number;
    newThisMonth: number;
    newToday: number;
  };
  transactions: {
    total: number;
    successful: number;
    successRate: number;
    totalVolume: number;
  };
}

export interface UserGrowthPoint {
  label: string;
  count: number;
}

export interface TransactionVolumePoint {
  label: string;
  transactionCount: number;
  volume: number;
  fees: number;
}

export interface ReminderOutcomes {
  window: { fromDate: string | null; toDate: string | null };
  requests: {
    total: number;
    reminded: number;
    totalReminders: number;
  };
  whatsapp: {
    sent: number;
    delivered: number;
    read: number;
    failed: number;
    totalWithReminder: number;
    deliveryRate: number;
    readRate: number;
    failureRate: number;
  };
  email: { reachablePayees: number };
  optOuts: { total: number; inWindow: number };
}

export const analyticsApi = {
  getOverview: async () => {
    const { data } = await apiClient.get<ApiResponse<AnalyticsOverview>>(
      "/admin/analytics/overview",
    );
    return data.data;
  },

  getUserGrowth: async (fromDate?: Date, toDate?: Date) => {
    const params: Record<string, string> = {};
    if (fromDate) params.fromDate = fromDate.toISOString();
    if (toDate) params.toDate = toDate.toISOString();

    const { data } = await apiClient.get<ApiResponse<UserGrowthPoint[]>>(
      "/admin/analytics/users",
      { params },
    );
    return data.data;
  },

  getTransactionVolumes: async (fromDate?: Date, toDate?: Date) => {
    const params: Record<string, string> = {};
    if (fromDate) params.fromDate = fromDate.toISOString();
    if (toDate) params.toDate = toDate.toISOString();

    const { data } = await apiClient.get<ApiResponse<TransactionVolumePoint[]>>(
      "/admin/analytics/transactions",
      { params },
    );
    return data.data;
  },

  getReminderOutcomes: async (fromDate?: Date, toDate?: Date) => {
    const params: Record<string, string> = {};
    if (fromDate) params.fromDate = fromDate.toISOString();
    if (toDate) params.toDate = toDate.toISOString();
    const { data } = await apiClient.get<ApiResponse<ReminderOutcomes>>(
      "/admin/analytics/reminders",
      { params },
    );
    return data.data;
  },
};
